import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { StripeService } from './stripe.service';

/* istanbul ignore next */
export class StripeGuestCheckoutService extends StripeService {
  constructor(
    private httpClient: HttpClient,
    protected appConfig: AppConfigSettings,
  ) {
    super(appConfig);
  }

  createCheckoutSession() {
    return of();
  }

  public getCheckoutSessionSummaryV1() {
    return of();
  }
}
